import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centersearch',
  templateUrl: './centersearch.component.html',
  styleUrls: ['./centersearch.component.css']
})
export class CentersearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
